
      
  <mat-toolbar>
    <span>Guest Purchase</span>
    <span class="fill-remaining-space"></span>
    <button class="btn-dialog-close" mat-stroked-button (click)="onClose()"><mat-icon>clear</mat-icon></button>
  </mat-toolbar>


<form [formGroup]="form"  autocomplete="off"  (ngSubmit)="saveButtonClick()" class="normal-form">
  <mat-grid-list cols="1" rowHeight="470px">
    <mat-grid-tile>
      <div class="row">
        <input readonly type="hidden" formControlName="id"> 
        <input readonly type="hidden" formControlName="guestId">       
      </div>    
      <div class="controles-container">
        <mat-form-field>
          <input  formControlName="guestName" [readonly]="isReadOnly" (focusout)="getCustomerDetails()"   matInput  [matAutocomplete]="autoGuest" placeholder="Guest Name">
          <mat-autocomplete autoActiveFirstOption  #autoGuest="matAutocomplete">
            <mat-option *ngFor="let option of filteredCustomerList | async" [value]="option.GuestName">
              {{option.GuestName}}
            </mat-option>
          </mat-autocomplete>   
          <mat-error *ngIf="formErrors.guestName">{{formErrors.guestName}}</mat-error>
        </mat-form-field>

          <mat-form-field>
            <input  formControlName="purchaseDate" matInput [matDatepicker]="picker" placeholder="Purchase Date">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
            <mat-error *ngIf="formErrors.purchaseDate">{{formErrors.purchaseDate}}</mat-error>
          </mat-form-field> 

        <mat-form-field>
          <input  formControlName="itemCode" [readonly]="isReadOnly" (focusout)="getItemData()"   matInput  [matAutocomplete]="auto" placeholder="Item Code">
          <mat-autocomplete autoActiveFirstOption  #auto="matAutocomplete">
            <mat-option *ngFor="let option of filteredOptions | async" [value]="option.ItemCode">
              {{option.ItemCode}}
            </mat-option>
          </mat-autocomplete>   
          <mat-error *ngIf="formErrors.itemCode">{{formErrors.itemCode}}</mat-error>
        </mat-form-field>
        <mat-form-field>
          <input formControlName="description" readonly matInput placeholder="Description">
          <mat-error *ngIf="formErrors.description">{{formErrors.description}}</mat-error>
        </mat-form-field>
        <mat-form-field>
          <input formControlName="unitPrice" (focusout)="calEachItemAmount()" (keyup)="calEachItemAmount()" [readonly]="isReadOnly" matInput placeholder="Unit Price">
          <mat-error *ngIf="formErrors.unitPrice">{{formErrors.unitPrice}}</mat-error>
        </mat-form-field>
        <mat-form-field>
          <input formControlName="qty" [readonly]="isReadOnly" matInput placeholder="Qty" (focusout)="calEachItemAmount()" (keyup)="calEachItemAmount()">
          <mat-error *ngIf="formErrors.qty">{{formErrors.qty}}</mat-error>
        </mat-form-field>
        <mat-form-field>
          <input formControlName="amount" readonly matInput placeholder="Amount">
          <mat-error *ngIf="formErrors.amount">{{formErrors.amount}}</mat-error>
        </mat-form-field>

        <div class="button-row">
            <button  *ngIf="showBtn"  class="float-right" mat-raised-button color="primary" type="submit">
              <span *ngIf ="showProcessingIndicator" class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
              Save
            </button> 
            <button type="button" class="float-right" mat-button (click)="onClose()">Cancel</button>   
          </div>
      </div>
    </mat-grid-tile>
  </mat-grid-list>
</form>

 <!-- Form Values : {{ form.value | json }} -->
